import React from 'react'
import type { Img } from '@/services/images'

interface AttributionProps {
  image: Img | undefined
  className?: string
  style?: React.CSSProperties
}

// Subtle photographer credit rendered under/on image galleries per Unsplash TOS.
export function Attribution({ image, className = '', style }: AttributionProps) {
  if (!image?.photographer) return null
  return (
    <a
      href={image.photographerUrl || '#'}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      onClick={(e) => e.stopPropagation()}
      style={{
        fontFamily: 'var(--sans)',
        fontSize: 10,
        color: 'rgba(248,245,239,0.55)',
        textDecoration: 'none',
        ...style,
      }}
    >
      ◈ {image.photographer}
    </a>
  )
}
